import { Card } from '@/components/Bicester';
import React from 'react';
import ServiceInfo from '../../components/ServiceInfo';
import { fetchAddEditPackage, fetchPackageInfo } from '@/services/site/giftwrap';
import { defaultGiftWrapInfo, giftwrapSchema } from '../../GiftWrap/constants';

const GiftWrapInfo = () => {
  return (
    <ServiceInfo
      defaultServiceInfo={defaultGiftWrapInfo}
      serviceSchema={giftwrapSchema}
      fetchInfo={fetchPackageInfo}
      fetchEdit={fetchAddEditPackage}
      getDefaultInfo={(data) => {
        return {
          num: data?.num,
          money: data?.money,
          pos_no: data?.pos_no,
        };
      }}
      getSubmitData={(id, values) => Object.assign({}, values, { id })}
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Input required isEdit={isEdit} label="包装数量" inputType="number" formKey="num" />
          <Card.Input
            required
            isEdit={isEdit}
            label="收费总金额"
            inputType="price"
            formKey="money"
          />
          <Card.Input isEdit={isEdit} label="POS小票编号" formKey="pos_no" />
        </>
      )}
    />
  );
};

export default GiftWrapInfo;
